export const APP_PAGE_TITLE = "Номин - Хүний хэрэгцээ цөм багтсан"
export const APP_META_TITLE = "nomin.mn"
export const APP_META_DESCRIPTION = "Хэрэглээг дижиталаар, Илүү хялбараар"

// Canonical site identity used for SEO (canonical URLs, structured data, OG tags)
export const SITE_URL = "https://nomin.mn"
export const SITE_NAME = "Nomin.mn"
export const SITE_ALT_NAME = "Номин онлайн дэлгүүр"
export const SITE_LOGO = "https://assets.nomin.mn/web/logo/nomin_logo_brand_color.svg"
export const SITE_SAME_AS = [
  "https://www.facebook.com/nomin.mn",
  "https://play.google.com/store/apps/details?id=mn.nomin.eshop",
  "https://www.nomin.co",
]
export const DEMO_API_URL = "https://vendure.nomin.mn/shop-api"
// export const DEMO_API_URL = "http://localhost:4000/shop-api"
// export const DEMO_API_URL = "http://192.168.202.239:4000/shop-api"
export const ROOT_COLLECTION = "38000"
export const ROOT_COLLECTIONS = [ROOT_COLLECTION]

export let API_URL =
  typeof process !== "undefined"
    ? process.env.VENDURE_API_URL ?? DEMO_API_URL
    : DEMO_API_URL

/**
 * This function is used when running in Cloudflare Pages in order to set the API URL
 * based on an environment variable. Env vars work differently in CF Pages and are not available
 * on the `process` object (which does not exist). Instead, it needs to be accessed from the loader
 * context, and if defined we use it here to set the API_URL var which will be used by the
 * GraphQL calls.
 *
 * See https://developers.cloudflare.com/workers/platform/environment-variables/#environmental-variables-with-module-workers
 */
export function setApiUrl(apiUrl: string) {
  API_URL = apiUrl
}

export const PAGINATON_DEFAULT_LIMIT = 30
export const PAGINATION_ALLOWED_LIMITS = new Set<number>([
  15,
  PAGINATON_DEFAULT_LIMIT,
  60,
  120,
])

export const SESSION_CURRENT_SHIPPING = "currentShipping"
export const SESSION_SHIPPING_ADDRESSES = "shippingAddressesByCode"
export const SESSION_STOCK_LOCATION_CODE = "stockLocationCode"
export const SESSION_IS_MINI_APP = "isMiniApp"
export const SESSION_MINI_APP_NAME = "miniAppName"
export const SESSION_MINI_APP_AUTH_CODE = "miniAppAuthCode"
export const SESSION_MINI_APP_ACCESS_TOKEN = "miniAppAccessToken"
export const SESSION_MINI_APP_ACCESS_TOKEN_EXPIRES_AT =
  "miniAppAccessTokenExpiresAt"
export const SESSION_MINI_APP_REFRESH_TOKEN = "miniAppRefreshToken"
export const SESSION_MINI_APP_REFRESH_TOKEN_EXPIRES_AT =
  "miniAppRefreshTokenExpiresAt"
export const SESSION_MINI_APP_USER_INFO = "miniAppUserInfo"

export const AUTH_TOKEN_SESSION_KEY = "authToken"
